import { render, staticRenderFns } from "./_id.vue?vue&type=template&id=b5ac3364&scoped=true&"
import script from "./_id.vue?vue&type=script&lang=js&"
export * from "./_id.vue?vue&type=script&lang=js&"
import style0 from "./_id.vue?vue&type=style&index=0&id=b5ac3364&prod&lang=css&"
import style1 from "./_id.vue?vue&type=style&index=1&id=b5ac3364&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5ac3364",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {NoContent: require('/var/jenkins_home/workspace/prod-web-xfans/components/noContent.vue').default,Comment: require('/var/jenkins_home/workspace/prod-web-xfans/components/comment.vue').default,BlockUserDialog: require('/var/jenkins_home/workspace/prod-web-xfans/components/block/BlockUserDialog.vue').default})
